// extracted by mini-css-extract-plugin
export default {"popover":"infoValueWithPopover_popover__jWWjz"};